import * as React from 'react';

const ShareCircle = ({ size }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 49 49"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
    >
      <rect x=".5" y=".4502" width={size} height={size} rx="24" fill="#eee" />
      <path
        d="m32.5 19.117c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4z"
        stroke="#2B2A2A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m16.5 28.45c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4z"
        stroke="#2B2A2A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m32.5 37.784c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4z"
        stroke="#2B2A2A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m19.953 26.463 9.1067 5.3066"
        stroke="#2B2A2A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="m29.046 17.13-9.0934 5.3066"
        stroke="#2B2A2A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ShareCircle;
